<template>
  <div id="app">
      <div class="maincon">
        <div class="tab-tilte">
          <p @click="file=0" :class="{active:file==0}" style="margin-left: 0;cursor: pointer;">文档分类</p>
          <p @click="self_file()" :class="{active:file==1}" style="cursor: pointer;">内部文档</p>
          <p @click="self_subject()" :class="{active:file==2}" style="cursor: pointer;">内部题库</p>
        </div>
        <div class="tab-content">
          <Selffileclass v-show="file==0"></Selffileclass>
          <Selffilefile v-show="file==1" ref="Selffilefile" ></Selffilefile>
          <Selffilesubject v-show="file==2" ref="Selffilesubject"></Selffilesubject>
        </div>

</div>
  </div>

</template>

<script>
  import Selffileclass from './Class.vue';
  import Selffilesubject from './Subject.vue';
  import Selffilefile from './File.vue';



  export default {
    data() {
      return {
        file: 0,
      }
    },
    components: {
      Selffilefile: Selffilefile,
      Selffilesubject: Selffilesubject,
      Selffileclass: Selffileclass,
    },
      methods: {
		  self_file(){
			  let _this=this
			  _this.file='1'
        this.$refs.Selffilefile.get_file();
        this.$refs.Selffilefile.get_type();
        this.$refs.Selffilefile.get_video();
		  },
      self_subject(){
        let _this=this
        _this.file='2'
        this.$refs.Selffilesubject.get_subject();
        this.$refs.Selffilesubject.get_file();
      }
      },

  }
</script>

<style scoped>



  .maincon {
   padding: 20px;
   height: calc(100vh - 40px);
   overflow-y: auto;
  }

  .tab-tilte {
    height: 41px;
  }

  .tab-tilte>p {
    float: left;
    margin: 0 5px;
    padding: 10px 15px;
    background-color: white;
    border: 1px solid #DCDCDC;
    border-bottom: none;
    border-radius: 5px 5px 0 0;
    font-size: 15px;
  }

  .active {

    border-bottom: 1px solid white !important;
  }

  .tab-content {
    background-color: white;
    border: 1px solid #DCDCDC;
    min-height: calc(100% - 83px);
    border-radius: 0px 5px 5px 5px;
    padding: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/view/company/course/SelfFile/SelfFile.vue